// Thin compatibility shim. Old code dispatched `navigationAction.open(...)`
// via Redux; under RR6 we don't have a routing reducer, so these are now
// fire-and-forget thunks that just push to history. The browser router
// listener (RR6 BrowserRouter) picks the change up automatically.
import { routes } from './path-definitions';

const noop = { type: '@@router/noop' as const };

export const navigationAction = {
	open: (url: string = routes.home, state?: any) => () => {
		window.history.pushState(state ?? null, '', url);
		// Tell RR6 BrowserRouter to re-read location. RR uses the popstate event.
		window.dispatchEvent(new PopStateEvent('popstate', { state: state ?? null }));
		return noop;
	},
	goBack: () => () => {
		window.history.back();
		return noop;
	}
};
